import React, { useContext, useEffect, useState } from 'react';
import { ServiceResponse } from '../../../app/services/shared/interfaces';
import LazyLoading from '../../../components/LazyLoading';
import { AppContext } from '../../../contexts/AppContext';
import useReactConfirmAlert from '../../../hooks/useReactConfirmAlert';
import { toast } from 'react-toastify';
import usePaymentMethodService from '../../../app/services/hooks/usePaymentMethodService';
import { PaymentMethodDataForm, defaultPaymentMethodDataForm } from '../../../app/models/PaymentMethod';
import PaymentMethodForm from './forms/PaymentMethodForm';
import ButtonCancelForm from '../../../components/buttons/ButtonCancelForm';
import ButtonSaveForm from '../../../components/buttons/ButtonSaveForm';

interface Props {
    paymentMethodId: number;
    onSaved?: () => void;
    onCancel?: () => void;
    onError?: () => void;
}

const PaymentMethodEdit = ({ paymentMethodId, onSaved, onCancel, onError }: Props) => {
    const { showLoading, hideLoading } = useContext(AppContext);
    const { fetchingEditPaymentMethod, editPaymentMethod, fetchingUpdatePaymentMethod, updatePaymentMethod } =
        usePaymentMethodService();
    const [paymentMethod, setPaymentMethod] = useState<PaymentMethodDataForm>(defaultPaymentMethodDataForm);
    const [errorFields, setErrorFields] = useState<any>();

    useEffect(() => {
        edit();
    }, []);

    const edit = () => {
        if (showLoading) showLoading('loading', 'Cargando forma de pago...');
        editPaymentMethod(paymentMethodId, {
            onSuccess: (response: ServiceResponse) => {
                setPaymentMethod(response.data.payment_method);
                if (hideLoading) hideLoading();
            },
            onError: (response: ServiceResponse) => {
                if (hideLoading) hideLoading();
                toast.error(response.message);
                if (onError) onError();
            }
        });
    };

    const update = () => {
        if (showLoading) showLoading('loading', 'Actualizando forma de pago...');
        updatePaymentMethod(paymentMethodId, paymentMethod, {
            onSuccess: (response: ServiceResponse) => {
                if (hideLoading) hideLoading();
                useReactConfirmAlert().successAlert({
                    title: 'Éxito',
                    message: response.message
                });
                toast.success(response.message, {
                    autoClose: 2500
                });
                if (onSaved) onSaved();
            },
            onError: (response: ServiceResponse) => {
                if (hideLoading) hideLoading();
                useReactConfirmAlert().errorAlert({
                    title: 'Error',
                    message: response.message
                });
            },
            onFieldError: (errorFields: ServiceResponse) => {
                if (hideLoading) hideLoading();
                setErrorFields(errorFields.data);
            }
        });
    };

    const cancel = () => {
        if (onCancel) onCancel();
    };

    return fetchingEditPaymentMethod ? (
        <LazyLoading height={300} />
    ) : (
        <>
            <div className="row">
                <div className="col-12">
                    <PaymentMethodForm
                        paymentMethodDataForm={paymentMethod}
                        setPaymentMethodDataForm={setPaymentMethod}
                        errorFields={errorFields}
                    />
                </div>
            </div>
            <hr />
            <div className="row justify-content-end">
                <div className="col-auto">
                    <ButtonCancelForm callbackCancel={cancel} locked={fetchingUpdatePaymentMethod} />
                </div>
                <div className="col-auto">
                    <ButtonSaveForm callbackSave={update} locked={fetchingUpdatePaymentMethod} />
                </div>
            </div>
        </>
    );
};

export default PaymentMethodEdit;
